<template>
    <TopNav v-if="showTopNav" />
    <main>
      <RouterView />
    </main>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import TopNav from './TopNav.vue';
import { authMethods } from './stores/auth.ts';

const route = useRoute();

// Hide TopNav on landing page
const showTopNav = computed(() => {
  return route.name !== 'Landing' && route.name !== 'LandingHome';
});

// Initialize auth state when app starts
onMounted(async () => {
  await authMethods.refresh();
});
</script>

<style>
main {
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}
</style>